import React from "react";
import InformTable from "../Components/InformTable";
import { formatDateIfValid } from "../utils/dateHelpers";

// Format A (object): { UpclickProductId, UpclickProductName, CreateDate, ModifyDate, ProductId, ... }
const renderMappingDeleted = (action: any) => {
    const data = [
        { property: "Upclick Product ID", value: String(action.UpclickProductId ?? "—") },
        { property: "Upclick Product Name", value: String(action.UpclickProductName ?? "—") },
        { property: "Product ID", value: String(action.ProductId ?? "—") },
        action.CreateDate
            ? { property: "Create Date", value: formatDateIfValid(action.CreateDate) ?? String(action.CreateDate) }
            : null,
    ].filter((row): row is { property: string; value: string } => row !== null);

    return (
        <div className="inform_panel">
            <InformTable data={data} label="Deleted Mapping" />
        </div>
    );
};

// Format B (array): [{ Id, GlobalOrderId, LicenseKey, UpclickProductId, StatusId, ... }]
const renderLicensesDeleted = (action: any[]) => (
    <>
        {action.map((record, idx) => (
            <div className="inform_panel" key={idx}>
                <InformTable
                    label={`License #${idx + 1}`}
                    data={[
                        { property: "License Key", value: String(record.LicenseKey ?? "—") },
                        { property: "Order ID", value: String(record.GlobalOrderId ?? "—") },
                        { property: "Upclick Product ID", value: String(record.UpclickProductId ?? "—") },
                        { property: "Status ID", value: String(record.StatusId ?? "—") },
                    ]}
                />
            </div>
        ))}
    </>
);

const MigrationDeleted: React.FC<{ action: any }> = ({ action }) => {
    if (Array.isArray(action)) return renderLicensesDeleted(action);
    return renderMappingDeleted(action);
};

export default MigrationDeleted;
